export default __webpack_public_path__ + "static/media/background-1.d63ab029.jpg";